import React from 'react';

export default function App() {
  return (
    <div style={{fontFamily: 'sans-serif', padding: 20}}>
      <h1>gmilliai.com</h1>
      <p>Development placeholder app.</p>
    </div>
  );
}
